import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from '../../Constant';
import Popup from '../RegisterScreen/Popup';
import MyProfilesidebar from '../Myprofile/MyProfilesidebar';

const ProfileUpdate = () => {
    const navigate = useNavigate();

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
    });

    const [popupVisible, setPopupVisible] = useState(false);
    const [popupMessage, setPopupMessage] = useState('');
    const [popupType, setPopupType] = useState('success');

    // Handle popup close
    const handleClosePopup = () => {
        setPopupVisible(false);
    };

    // Fetch user profile on component load
    useEffect(() => {
        const fetchUserProfile = async () => {
            try {
                const userId = localStorage.getItem('userId'); // Retrieve user_id from local storage
                if (!userId) {
                    throw new Error('User ID not found in local storage.');
                }

                const response = await fetch(`${api}edit_profile`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({ user_id: userId }),
                });
                const data = await response.json();
                if (data.success === "true") {
                    const { name, email, phone } = data.user;
                    setFormData({
                        name,
                        email,
                        phone,
                    });
                } else {
                    setPopupMessage(`Failed to fetch user details: ${data.message}`);
                    setPopupType('error');
                    setPopupVisible(true);
                }
            } catch (err) {
                setPopupMessage(`Error fetching user details: ${err.message}`);
                setPopupType('error');
                setPopupVisible(true);
            }
        };
        fetchUserProfile();
    }, []);

    // Handle form input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevState) => ({
            ...prevState,
            [name]: value,
        }));
    };

    // Handle form submission
    const handleSubmit = async (e) => {
        localStorage.removeItem('userName');
        localStorage.removeItem('userEmail');
        localStorage.removeItem('userPhone');
        e.preventDefault();
        try {
            const userId = localStorage.getItem('userId'); // Retrieve user_id from local storage
            if (!userId) {
                throw new Error('User ID not found in local storage.');
            }
            const response = await fetch(`${api}update_profile`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    user_id: userId,
                    name: formData.name,
                    phone: formData.phone,
                }),
            });

            const data = await response.json();

            
            if (data.success === "true") {
                localStorage.setItem('userName', formData.name);
                localStorage.setItem('userEmail', formData.email);
                localStorage.setItem('userPhone', formData.phone);
                setPopupMessage('Profile updated successfully.');
                setPopupType('success');
                setPopupVisible(true);
                // Optionally redirect after success
                setTimeout(() => navigate('/myprofile'), 2000);
                setTimeout(() => window.location.reload(), 3000);
            } else {
                setPopupMessage(`Failed to update profile: ${data.message}`);
                setPopupType('error');
                setPopupVisible(true);
            }
        } catch (err) {
            setPopupMessage(`Error updating profile: ${err.message}`);
            setPopupType('error');
            setPopupVisible(true);
        }
    };

    // Handle cancel button
    const cancelbtn = () => {
        navigate('/myprofile');
    };

    return (
        <div className="myprofile-bg pt-40 pb-40">
            <div className="container">
                <div className="row">
                    <div className="col-lg-3">
                        <MyProfilesidebar />
                    </div>
                    <div className="col-lg-9">
                        <div className="myprofile-overview">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="add-address-tittle">
                                        <h5>Update Profile</h5>
                                    </div>
                                </div>
                            </div>
                            <form className="row billing-form" onSubmit={handleSubmit}>
                                {/* Name Field */}
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <label>Name</label><br />
                                    <input
                                        type="text"
                                        name="name"
                                        value={formData.name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </div>

                                {/* Phone Field */}
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <label>Phone</label><br />
                                    <input
                                        type="text"
                                        name="phone"
                                        value={formData.phone}
                                        onChange={handleInputChange}
                                        maxLength='10'
                                    />
                                </div>
                                {/* Email Field */}
                                <div className="col-lg-6 col-sm-6 col-md-6">
                                    <label>Email</label><br />
                                    <input
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                        readOnly
                                    />
                                </div>

                                {/* Submit and Cancel Buttons */}
                                <div className="col-lg-12 sub-button">
                                    <button type="submit" className="submit">SUBMIT</button>
                                    <button type="button" className="cancel" onClick={cancelbtn}>CANCEL</button>
                                </div>
                            </form>
                            {popupVisible && (
                                <Popup
                                    message={popupMessage}
                                    title="Notice"
                                    type={popupType}
                                    onClose={handleClosePopup}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileUpdate;